import styled from 'astroturf/react';
import Svg from 'src/components/Svg';
import Button from 'src/components/Button';
import { EiqButton } from 'eiq-storybook';

const ActionButton = styled(Button)`
  min-width: 0;
  font-size: var(--ph-text-sm);
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: 0.86px;
  color: var(--white);
  padding: 10px 15px;
  &:not(.isDeleteButton) {
  background-color: var(--ph-green-500) !important;
  }

  &:hover {
    background-color: var(--ph-green-700);
  }

  &.isDeleteButton {
    background-color: var(--ph-red-500) !important;

    &:hover {
      background-color: var(--ph-red-700);
    }
  }

  &.rounded {
    border-radius: var(--ph-border-radius-sm);
  }

  &.disabled {
    background-color: var(--ph-gray-50) !important;
    color: var(--ph-gray-300);
    cursor: not-allowed;
    pointer-events: none;

    &:focus {
      box-shadow: none !important;
    }
  }
`;

const AddButton = styled(Svg)`
  width: 22px;

  circle {
    fill: var(--ph-light-blue-500);
  }
`;

const AddButtonLabel = styled('span')`
  position: relative;
  top: -5px;
  margin-left: 5px;
`;

const AddButtonWrapper = styled('div')`
  cursor: pointer;
`;

const Block = styled('div')`
  margin-bottom: 20px;

  &.flex {
    display: flex;
  }
`;

const FlexRow = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  h1 {
    flex: 1;
    font-family: var(--ph-font-family);
  }

  span,
  button,
  label {
    margin-left: 15px;
  }
`;

const BlockHeader = styled('span')`
  font-size: var(--ph-heading-five);
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: var(--black);
  margin-bottom: 5px;
`;

const Half = styled('div')`
  width: 50%;

  div[class*='Field'] {
    margin-bottom: 15px;
  }
`;

const Table = styled('table')`
  border-radius: var(--ph-border-radius-sm);
  background-color: var(--white);
  width: 100%;
  font-size: var(--ph-text-sm);
  box-shadow: var(--ph-box-shadow-sm);
  border-collapse: collapse;

  thead {
    border-radius: var(--ph-border-radius-sm);
    background-color: var(--ph-gray-100);
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    color: var(--white);
    padding: 0 10px;
  }

  td {
    border: 0;
    padding: 5px 10px;
  }
`;

const PageTitleAddition = styled('div')`
  float: right;
  margin-top: 10px;
  font-size: var(--ph-text-sm);
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: var(--black);
`;

const AvailableOffline = styled('div')`
  display: inline-block;
  margin-left: 10px;
  position: relative;
  width: 17px;
  height: 10px;
  border-radius: var(--ph-border-radius-sm);
  background-color: rgba(var(--ph-gray-rgb-500), 0.5);

  &::before {
    content: '';
    display: block;
    position: absolute;
    width: 14px;
    height: 14px;
    background-color: var(--ph-green-500);
    border-radius: var(--ph-border-radius-sm);
    left: 8px;
    top: -2px;
  }
`;

const UnavailableOffline = styled('div')`
  display: inline-block;
  margin-left: 10px;
  position: relative;
  width: 17px;
  height: 10px;
  border-radius: var(--ph-border-radius-sm);
  background-color: rgba(var(--ph-gray-rgb-500), 0.5);
  cursor: pointer;

  &::before {
    content: '';
    display: block;
    position: absolute;
    width: 14px;
    height: 14px;
    border: 1px solid rgba(var(--ph-gray-rgb-500), 0.4);
    background-color: var(--white);
    border-radius: var(--ph-border-radius-sm);
    left: -5px;
    top: -2px;
  }
`;

const JobStatus = styled('div')`
  position: absolute;
  top: 0;
  right: 0;

  span {
    font-size: var(--ph-text-sm);
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.25;
    letter-spacing: normal;
    color: var(--black);
    margin-right: 30px;
  }

  button {
    font-size: var(--ph-text-sm);
    padding: 10px 20px;
    min-width: 0;
    margin-left: 10px !important;

    &[disabled] {
      background-color: var(--disabled-button);
      background-image: none;
      opacity: 0.4;
      cursor: default;
    }
  }
`;

const JobStatusIcon = styled(Svg)`
  width: 17px;
  margin-right: 5px;
`;

const StatusButton = styled(Button)`
  min-width: 0;
  font-size: var(--ph-text-sm);
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: 0.86px;
  color: var(--white);
  padding: 10px 15px;

  &.rounded {
    border-radius: var(--ph-border-radius-sm);
  }

  &.disabled {
    background-color: var(--ph-gray-50) !important;
    color: var(--ph-gray-300);
    cursor: not-allowed;
    pointer-events: none;

    &:focus {
      box-shadow: none !important;
    }
  }

  &.hide {
    display: none;
  }
`;

const PdfWrapper = styled('div')`
  display: none;
`;

const LinkButton = styled(Button)`
  border-bottom: 0 !important;
`;

const ConfirmButton = styled(Button)`
  padding: 15px;
  min-width: 100px;
`;

const Status = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const StatusText = styled('span')`
  font-size: var(--ph-text-sm);
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: var(--black);

  &.pendingFindings {
    line-height: 1.37;
  }
`;

const StatusSendNotification = styled('span')`
  font-size: var(--ph-text-sm);
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: var(--black);
  display: flex;
  width: 135px;
  align-items: center;
  white-space: nowrap;
  margin-right: 15px;
`;

const ColorField = styled('label')`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
  color: var(--white);
  border-radius: var(--ph-border-radius-sm);

  &.status-red {
    background-color: var(--ph-red-500);
  }

  &.status-yellow {
    background-color: var(--ph-yellow-500);
  }

  &.status-green {
    background-color: var(--ph-green-500);
  }
`;

const FieldLabel = styled('div')`
  font-size: var(--ph-text-sm);
  color: var(--white);
`;

const FieldText = styled('div')`
  padding-left: 10px;
  font-size: var(--ph-text-sm);
  color: var(--white);
`;

const ActionRequiredCount = styled('span')`
  color: var(--white);
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: var(--ph-red-500);
  font-size: var(--ph-text-sm);
  display: inline-block;
  text-align: center;
  line-height: 20px;
  margin-left: 10px;
`;

const MandatoryQuestionNotfilledCount = styled('span')`
  color: var(--white);
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: var(--ph-orange-500);
  font-size: var(--ph-text-sm);
  display: inline-block;
  text-align: center;
  line-height: 20px;
  margin-left: 10px;

  span {
    width: 120px;
    bottom: 100%;
    left: 50%;
    margin-left: -60px; 
    background-color: black;
    color: #fff;
    text-align: center;
    padding: 5px 0;
    border-radius: 6px;
   
    /* Position the tooltip text - see examples below! */
    position: absolute;
    z-index: 1;
  }
`;

const PieChartText = styled('span')`
  position: absolute;
  font-size: var(--ph-text-sm);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin-left: 0 !important;
`;

const PieChartDiv = styled('div')`
  width: 40px;
  height: 40px;
  position: relative;
`;

const SummaryInfoSeperator = styled('div')`
  border-left: 1px solid grey;
  height: 22px;
`;

const Title = styled('span')`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: var(--ph-heading-three);
`;

const SubmitButton = styled(Button)`
  padding: 13px 41px;
  min-width: 0;
`;

const Wrapper = styled('div')`
  div[class*=rc-tabs-tab] {
    line-height: 26px;
    overflow: unset;
  }
  div[class*='rc-tabs-tab-active'] {
    min-height: 34px;
  }
  &.busyCursor{
    cursor: progress;
    div[class*=rc-tabs-tab] {
      cursor: progress !important;
    }
  }
`;

const DeferNotificationWrapper = styled('div')`
  width: 170px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const DeferNotificationLabel = styled('span')`
  text-align: center;
  font-size: 12px;
  margin: 0 5px 5px;
`;

const DeferNotificationCountdown = styled('span')`
  margin: 0;
  text-align: center;
  font-size: 14px;
`;

const JobAdministrationHeaderWrapper = styled('div')`
  display: flex;
  justify-content: space-between;
`;

const MissingTagsDescription = styled('div')`
  margin-top: 15px;
`;

const NewSaqStatusesRowWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 25px;

  h2 {
    font-family: var(--ph-font-family-lato-heavy);
    font-size: var(--ph-required-title);
  }

  [class*='d-flex'] {
    display: flex;
  }

  [class*='btn--solid'] {
    background: rgb(15 242 178 / var(--tw-border-opacity)) !important;
  }

  button {
    margin-left: 15px;
    font: normal normal 700 13px / 15px var(--ph-font-family-lato-regular);
    font-size: 13px !important;
    line-height: 1 !important;
    &[class*='btn--link-border'] span, span {
      border-bottom: 1px solid transparent;
    }
    &:hover span {
      border-color: #0F1232;
    }
  }
`;

const SaqConfirmationModalWrapper = styled('div')`
  [class*='small-container'] {
    left: calc(50% - 250px) !important;
    top: 30%;
    width: 400px;
    padding: 40px;

    [class*='modal-title'] {
      text-align: center;
      font-weight: 700;
      margin-bottom: 30px;
    }

    [class*='btn--solid'] {
      background: rgb(15 242 178 / var(--tw-border-opacity)) !important;
      width: 150px;
    }
    
    [class*='saq-modal-body'] {
      margin-bottom: 30px;

      p {
        text-align: center;
        margin-bottom: 5px;
      }
    }

    button {
      font: normal normal 700 13px / 15px var(--ph-font-family-lato-regular);
      font-size: 13px !important;
      line-height: 1 !important;
      &[class*='btn--link-border'] span, span {
        border-bottom: 1px solid transparent;
      }
      &:hover span {
          border-color: #0F1232;
      }
    }
  }
`;

const SaqModalButtonsWrapper = styled('div')`
  display: flex;
  justify-content: space-between;

  [class*='button-wrapper'] {
    padding: 0 35px;
    margin-left: 0px;
  }
`
const SaqDownloadDropdownWrapper = styled('div')`
  div[class*='SelectInputWrapper']{
    margin-bottom: 0;
    margin-left: 15px;
  }
  div[class*='react-select__control'] {
    width: 180px;
    height: 28px;
    min-height: 28px !important;
    border-color: var(--dark-gray);
  }
  div[class*='react-select__menu'] {
    border-color: var(--dark-gray);
    border-top: none;
    box-shadow: var(--black-20) 0px 1px 4px 0.3px;
  }
  div[class*='react-select__single-value']{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 127px;
    display: inline-block;
  }
  div[class*='react-select__single-value']:hover {
    text-overflow: clip;
    white-space: normal;
    word-break: break-all;
  }
  div[class*='react-select__value-container'], div[class*='react-select__single-value'], div[class*='react-select__option'] {
    font-family: "Source Sans Pro";
    font-size: 13px;
  }
  div[class*='react-select__input']{
    caret-color: transparent;
  }
`

const Spinner = styled('div')`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  div[class*='loading']{
    width: 100%;
    height: 100%;
    margin: auto;
    background: transparent;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const ReopenCapButton = styled(EiqButton)`
  height: 28px !important;
  background: var(--cyan-green) 0% 0% no-repeat padding-box !important;
  opacity: 1;
  text-align: center;
  font: normal normal bold 13px/15px var(--ph-font-family-lato-regular);
  letter-spacing: 0px;
  color: var(--dark-blue);
  opacity: 1;  
  padding: 0px 10px !important;
  span{
    margin: 0;
  }
`;

export default {
  ActionButton,
  ActionRequiredCount,
  AddButton,
  AddButtonLabel,
  AddButtonWrapper,
  AvailableOffline,
  Block,
  BlockHeader,
  ColorField,
  ConfirmButton,
  DeferNotificationCountdown,
  DeferNotificationLabel,
  DeferNotificationWrapper,
  FieldLabel,
  FieldText,
  FlexRow,
  Half,
  JobAdministrationHeaderWrapper,
  JobStatus,
  JobStatusIcon,
  LinkButton,
  PageTitleAddition,
  PdfWrapper,
  PieChartDiv,
  PieChartText,
  Status,
  StatusButton,
  StatusSendNotification,
  StatusText,
  SubmitButton,
  SummaryInfoSeperator,
  Table,
  Title,
  UnavailableOffline,
  Wrapper,
  MissingTagsDescription,
  MandatoryQuestionNotfilledCount,
  NewSaqStatusesRowWrapper,
  SaqConfirmationModalWrapper,
  SaqModalButtonsWrapper,
  SaqDownloadDropdownWrapper,
  Spinner,
  ReopenCapButton
};
